import SiteManager from '@/module/resourceCenter/page/siteManager.vue'
import DeviceManager from '@/module/resourceCenter/page/deviceManager.vue'
import CharginggunManager from '@/module/resourceCenter/page/charginggunManager.vue'
import RateManager from '@/module/resourceCenter/page/rateManager.vue'
import SimCardManager from '@/module/resourceCenter/page/simCardManager.vue'
import GunBoxManager from '@/module/resourceCenter/page/gunBoxManage.vue'

// import RuleManager from '@/module/resourceCenter/page/ruleManager.vue'
import TypeManager from '@/module/resourceCenter/page/typeManager.vue'
import PersonPileManager from '@/module/resourceCenter/page/personPileManager.vue'
import CarManager from '@/module/resourceCenter/page/car/carManager.vue'
import AppointmentManager from './../page/appointmentManager/appointmentManager.vue'
import MeterAcquisitionManager from '@/module/resourceCenter/page/acquisitionManager.vue'
import layout from '@/layout/index'
// 导出配置的路由器
export default [{
  path: '/resourceCenter',
  component: layout,
  redirect: 'resourceCenter/siteManager',
  meta: {
    title: '资源中心',
    icon: 'icon-ziyuan',
    perms: ['bee:res']
  },
  children: [
    {
      path: 'siteManager',
      component: SiteManager,
      meta: {
        title: '充电站管理',
        icon: 'icon-changzhan',
        perms: ['bee:res:station']
      }
    },
    {
      path: 'deviceManager',
      component: DeviceManager,
      meta: {
        title: '充电桩管理',
        icon: 'icon-shebei1',
        perms: ['bee:res:pile']
      }
    },
    {
      path: 'charginggunManager',
      component: CharginggunManager,
      meta: {
        title: '充电枪管理',
        icon: 'icon-chongdianqiang',
        perms: ['bee:res:gun']
      }
    },
    {
      path: 'rateManager',
      component: RateManager,
      meta: {
        title: '费率管理',
        icon: 'icon-feishuaiguanli',
        perms: ['bee:res:rate']
      }
    },
    {
      path: 'gunBoxManager',
      component: GunBoxManager,
      meta: {
        title: '箱变管理',
        icon: 'icon-feishuaiguanli',
        perms: ['bee:res:gunBox']
      }
    },
    {
      path: 'simCardManager',
      component: SimCardManager,
      meta: {
        title: 'Sim卡管理',
        icon: 'icon-qia2',
        perms: ['bee:res:simCard']
      }
    },
    {
      path: 'typeManager',
      component: TypeManager,
      meta: {
        title: '充电桩型号管理',
        icon: 'icon-xinghao1',
        perms: ['bee:res:pileType']
      }
    },
    // {
    //   path: 'personPileManager',
    //   component: PersonPileManager,
    //   meta: {
    //     title: '个人桩管理',
    //     icon: 'icon-qia2',
    //     perms: ['bee:member:group']
    //   }
    // },
{
      path: 'carManager',
      component: CarManager,
      meta: {
        title: '车辆管理',
        icon: 'icon-cheliang',
        perms: ['bee:res:car']
      }
    },{
      path: 'appointmentManager',
      component: AppointmentManager,
      meta: {
        title: '预约管理',
        icon: 'icon-yuyue',
        perms: ['bee:res:appoint']
      }
    },
    {
      path: 'meterConfigurationManager',
      component: () => import("@/module/resourceCenter/page/meterConfigurationManager.vue"),
      meta: {icon: 'icon-caozuo', title: '抄表配置',perms:['bee:res:meter']}
    },
    {
      path: 'meterAcquisitionManager',
      component: MeterAcquisitionManager,
      meta: {
        title: '抄表终端', icon: 'icon-cheliang', perms: ['bee:res:meter']
      }
    },
    {
      path: 'paramMeter',
      component: () => import("@/module/resourceCenter/page/meterManager.vue"),
      meta: {icon: 'icon-caozuo', title: '电表管理',perms:['bee:res:meter']}
    },
    {
     path: 'pileDateQueManager',
     component: () => import("@/module/resourceCenter/page/pileDateQueManager.vue"),
     meta: {icon: 'icon-caozuo', title: '采集统计',perms:['bee:res:meter']}
    },
    {
     path: 'businessOperatorManager',
     component: () => import("@/module/resourceCenter/page/businessOperatorManager.vue"),
     meta: {icon: 'icon-caozuo', title: '营业商管理',perms:['bee:res:business']}
    },
    {
     path: 'simRenewManager',
     component: () => import("@/module/resourceCenter/page/simRenewManager.vue"),
     meta: {icon: 'icon-caozuo', title: 'sim支付管理',perms:['bee:res:simCard:getSimCardLogs']}
    },

    // {
    //   path: 'meterAcquisitionManager',
    //   component: () => import("@/module/resourceCenter/page/acquisitionManager.vue"),
    //   meta: {icon: 'icon-caozuo', title: '抄表终端采集',perms:['bee:res:terminal']}
    // },
  ]
}]



// WEBPACK FOOTER //
// ./src/module/resourceCenter/router/index.js